import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconModule } from '@hglobal/fin-ui';

import { UserProfile } from '@kr/models';

@Component({
  imports: [IconModule],
  selector: 'kr-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCardComponent {
  user = input<UserProfile>();

  get firstLetter(): string {
    return this.user()?.firstName[0].toUpperCase();
  }
}
